import { createContext } from "react";
export const EmailContext=createContext();